module.exports = __webpack_public_path__ + "img/mall2.fff85b24.png";